import { useNavigate } from 'react-router-dom';

import { PATH } from 'constants/path';

export const useLearnLayout = () => {
  const navigateTo = useNavigate();

  const goToAddPage = () => {
    navigateTo(`${PATH.LEARNERS}/${PATH.LEARNER_ADD}`);
  };

  return { goToAddPage };
};
